import Theme from '@adsk/alloy-react-theme';

export const modalStyle = {
  maxWidth: '600px',
  width: '100%',
  maxHeight: '90vh',
  height: 'auto',
};

export const modalBodyStyle = {
  minHeight: '180px',
  paddingBottom: '40px',
};

export const fieldStyle = {
  paddingTop: '20px',
  width: '100%',
};

export const firstColumnFieldStyle = {
  padding: '20px 20px 0 0',
  width: '50%',
};

export const secondColumnFieldStyle = { paddingTop: '20px', width: '50%' };

export const flexWrapperStyle = { display: 'flex' };

export const secondColumnNoLabelFieldStyle = {
  paddingTop: '44px',
  width: '50%',
};

export const timezoneTooltipLinkStyle = {
  color: Theme.colors.white,
  textDecoration: 'none',
  ...Theme.typography.bodySmallBold,
};

export const templateTooltipLinkDividerStyle = {
  margin: '10px 0',
};

export const templateTooltipLinkStyle = timezoneTooltipLinkStyle;

export const loaderContainerStyle = {
  zIndex: 100,
  width: '100%',
  height: '100%',
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  top: '0px',
  left: '0px',
};

export const loaderBoxStyle = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'rgba(238,238,238,0.6)',
  borderRadius: '15px',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '20px',
};

export const ringCustomStyle = {
  width: 40,
  height: 40,
};

export const loaderTextStyle = { marginTop: '5px' };

export const templateLabelContainer = {
  display: 'flex',
};

export const templateLabelInfoPopover = {
  marginLeft: 5,
};

export const templateLabelInfoPopoverIcon = {
  color: '',
};

export const templateGroupLabel = {
  container: {
    fontSize: 11,
  },
  title: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginBottom: 5,
    marginTop: 2,
  },
};
